import { render, staticRenderFns } from "./report-issue.vue?vue&type=template&id=537e9c2c&scoped=true&"
import script from "./js/report-issue.js?vue&type=script&lang=js&"
export * from "./js/report-issue.js?vue&type=script&lang=js&"
import style0 from "./report-issue.vue?vue&type=style&index=0&id=537e9c2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537e9c2c",
  null
  
)

export default component.exports